import React from 'react';
import Schema from 'components/Schema';
import PropTypes from 'prop-types';

const PodcastsSchema = ({ name, description, abstract, author, numberOfEpisodes, id, image, keywords }) => {
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'RadioSeries',
    name,
    description,
    abstract,
    author: {
      '@type': 'Person',
      name: author,
    },
    numberOfEpisodes,
    url: `https://juke.nl/podcasts/${id}`,
    id: `https://juke.nl/podcasts/${id}`,
    image,
    keywords,
  };
  return <Schema data={schema} />;
};

PodcastsSchema.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  abstract: PropTypes.string,
  author: PropTypes.string,
  numberOfEpisodes: PropTypes.number,
  id: PropTypes.string,
  image: PropTypes.string,
  keywords: PropTypes.string,
};

PodcastsSchema.defaultProps = {
  name: null,
  description: null,
  abstract: null,
  author: null,
  numberOfEpisodes: null,
  id: null,
  image: null,
  keywords: null,
};
export default PodcastsSchema;
